export const paths = {
  root: '/ostoslistat',
  list: (id: string) => `/ostoslistat/${id}`,
}
